import React, { useRef, useState } from 'react';
import { image } from '../../../app/utils/common/image';

const ProfileImageModal = ({ isOpen, onClose, currentImage, onUpdateImage }) => {
    const fileRef = useRef(null);
    const [newProfilePhoto, setNewProfilePhoto] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newProfilePhoto) {
            onUpdateImage(newProfilePhoto);
            setNewProfilePhoto(null);
            onClose();
        }
    };
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] p-4">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-[300px] border border-gray-300">
                <h2 className="text-xl font-semibold mb-4 !text-black">Update Profile Picture</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="file"
                        className="hidden"
                        accept="image/*"
                        ref={fileRef}
                        onChange={(e) => {
                            if (e.target.files) {
                                setNewProfilePhoto(e.target.files[0]);
                            }
                        }}
                    />
                    <div className="relative w-32 h-32 mx-auto">
                        <img
                            className="rounded-full shadow-md w-full h-full object-cover"
                            src={
                                newProfilePhoto
                                    ? URL.createObjectURL(newProfilePhoto)
                                    : currentImage || ""
                            }
                            alt="profile"
                        />
                        <div
                            className="absolute bottom-0 right-0 bg-white cursor-pointer p-2 border-2 rounded-full shadow-md"
                            onClick={() => fileRef.current?.click()}
                        >
                            <img className="h-[21px] w-[23px]" src={image.CAMERA_ICON} alt="camera" />
                        </div>
                    </div>
                    <div className="flex justify-center gap-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-sky-900 text-white rounded-md hover:bg-sky-800 cursor-pointer transition duration-200"
                            disabled={!newProfilePhoto}
                        >
                            Update
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ProfileImageModal; 